module["exports"] = [
  "example.org",
  "example.com",
  "example.net"
];
